import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/parashiot")({
  head: () => ({ meta: [{ title: "Parashiot · Beit Tefilah Rechovot" }] }),
  component: () => <Outlet />,
});
